/*
| Per-screen teardown scope for soft navigation. Page inits bind some document/
| window-level listeners; on a soft-nav swap those inits re-run, which would stack
| duplicate global listeners (and re-fire events like planning:week-rendered).
|
| Inits pass `{ signal: screenSignal() }` to their document/window addEventListener
| calls; softNav calls resetScreenScope() before re-init, aborting the previous
| screen's listeners so each navigation starts clean. Element-level listeners (on
| #screen children) need no signal — they are GC'd with the replaced node.
*/
let controller = new AbortController();

export const screenSignal = (): AbortSignal => controller.signal;

export const resetScreenScope = (): void => {
    controller.abort();
    controller = new AbortController();
};
